(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name acUtilizationReport.controller:AcUtilizationReportCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('acUtilizationReport').controller('AcUtilizationReportCtrl',
			AcUtilizationReportCtrl);

	function AcUtilizationReportCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'AcUtilizationReportCtrl';
	vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				fromTime : '00:00',
				toTime : '23:59',
				acRegistration : null
			},
			masterList : {
				acRegistrationList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				fromTimeInvalid : false,
				toTimeInvalid : false,
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchACUtilizationReport(params);
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			// if from date time before to date time
			if (!!vm.model.searchCriteria.fromDate
					&& !!vm.model.searchCriteria.fromTime
					&& !!vm.model.searchCriteria.toDate
					&& !!vm.model.searchCriteria.toTime
					&& !vm.model.masterList.fromDateFormatInvalid
					&& !vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromTimeInvalid
					&& !vm.model.masterList.toTimeInvalid
					&& !isFromDateBeforeToDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}
			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
			// if from time invalid
			if (!isValidTime(vm.model.searchCriteria.fromTime)) {
				vm.model.masterList.fromTimeInvalid = true;
			} else {
				vm.model.masterList.fromTimeInvalid = false;
			}
			// if from time invalid
			if (!isValidTime(vm.model.searchCriteria.toTime)) {
				vm.model.masterList.toTimeInvalid = true;
			} else {
				vm.model.masterList.toTimeInvalid = false;
			}
		}

		// check from date and to date
		function isFromDateBeforeToDate() {
			return moment(
					vm.model.searchCriteria.fromDate + " "
							+ vm.model.searchCriteria.fromTime,
					"DD/MM/YYYY HH:mm").isBefore(
					moment(vm.model.searchCriteria.toDate + " "
							+ vm.model.searchCriteria.toTime,
							"DD/MM/YYYY HH:mm"));
		}
		;
		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// validate time
		function isValidTime(time) {
			var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
			return regex.test(time);
		}
		;

		// search otp report
		function searchACUtilizationReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'air_craft_utilization.rptdesign', getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["fromTime"] = param.fromTime;
			searchParamMap["toTime"] = param.toTime;
			searchParamMap["acRegId"] = '';
			if (!!param.acRegistration && !!param.acRegistration.registrationId) {
				searchParamMap["acRegId"] = param.acRegistration.registrationId;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid
					|| vm.model.masterList.fromDateAfterToDate) {
				return false;
			} else {
				return true;
			}
		}

		(function() {
			// load aircraft Registration list
			CommonMasterData.getAcRegistrationList(function(acRegistrationList) {
				vm.model.masterList.acRegistrationList = acRegistrationList;
			}, function(error) {
				console.log('Aircraft Registration List retrieval error!!!');
			});

		})();
	}
}());